import React from 'react';
import PropTypes from 'prop-types';

import { messages } from '../../../../../../../enums/document-type';
import { ShipmentManifest } from '../../../../../../../containers/print-document-button-containers/shipments-grid/components/shipment-manifest';
import { emptyObject } from 'ui-components/default-props/empty';
import { useFulfillmentPlanForFulfillmentId } from '../../../../../../../hooks/entities/selectors/fulfillments';
import {
  ORDER_DETAILS_ACTIONS,
  useTrackOrderDetailsAction,
} from '../../../../../../modals/order-details-modal/event-tracking/use-track-order-details-action';
import { buildShipmentManifestData } from '../../../../../../../containers/print-document-button-containers/order-details/helper/build-shipment-manifest-data';

export const PrintShipmentManifestMenuItem = ({ fulfillmentId }) => {
  const fulfillmentPlan = useFulfillmentPlanForFulfillmentId(fulfillmentId) || emptyObject;
  const shipmentManifestData = buildShipmentManifestData([fulfillmentPlan]);

  const trackShipmentManifestClicks = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.PRINT_SHIPMENT_MANIFEST);

  return (
    <ShipmentManifest
      name={messages.printShipmentManifest}
      selectedData={shipmentManifestData}
      trackOnClick={trackShipmentManifestClicks}
    />
  );
};

PrintShipmentManifestMenuItem.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};
